import React from 'react';

import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';
import { Textfield } from 'react-mdl';

const ModalBuscaCamerasFilter = (props) => {
  console.log(props);
  return (
    <div className="filter-box">
      <Textfield
        onChange={ ev => props.onFilterChange(ev.target.value) }
        label="Digite o Local"
        style={{ width: '400px' }}
      />
    </div>
  );
};

export default ModalBuscaCamerasFilter;



// WEBPACK FOOTER //
// ./src/components/ModalBuscaCameras/Filter.js